(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("plotly_custom_datepicker", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["plotly_custom_datepicker"] = factory(require("react"), require("react-dom"));
	else
		root["plotly_custom_datepicker"] = factory(root["React"], root["ReactDOM"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__33__) => {
return 